import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: ""
}
const _hoisted_2 = {
  class: "",
  style: {"max-height":"480px","overflow-y":"auto"}
}

import { computed } from 'vue'
import { formLabelStyle } from '@/components/cmForm/globalOpt'


export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorSubnetDialog',
  props: {
  modelValue: {
    type: Boolean,
    default: false
  },
  failedScanList: {
    type: Array as () => string[],
    default: () => []
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const dialogVisible = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
})

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
    title: _ctx.$t('errorSubnetDialog.title'),
    width: 450
  }, {
    default: _withCtx(() => [
      (__props.failedScanList && __props.failedScanList.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              style: _normalizeStyle(_unref(formLabelStyle)),
              class: "cm-ui-mb15"
            }, _toDisplayString(_ctx.$t('errorSubnetDialog.failedTip', { count: __props.failedScanList.length })), 5),
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.failedScanList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "cm-align-center gap-x-5",
                  style: {"line-height":"1.4rem","color":"var(--el-color-danger)"},
                  key: index
                }, [
                  _createElementVNode("span", null, _toDisplayString(item), 1)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})